import Vue from 'vue'
import Vuex from 'vuex'
import { isTokenExpired } from '../utils/token'

Vue.use(Vuex)

function projectGroupStorageKey(userId) {
  return `selectedProjectGroupId_${userId}`
}

function normalizeProjectGroupIds(ids) {
  return (ids || [])
    .map(id => Number(id))
    .filter(id => !Number.isNaN(id))
}

function resolveSelectedProjectGroupId(user) {
  if (!user || !isProjectScopedUser(user)) {
    return null
  }
  const ids = normalizeProjectGroupIds(user.projectGroupIds)
  if (!ids.length) {
    return null
  }
  const key = projectGroupStorageKey(user.userId)
  const stored = localStorage.getItem(key)
  if (stored) {
    const parsed = Number(stored)
    if (ids.includes(parsed)) {
      return parsed
    }
  }
  return ids[0]
}

function isProjectScopedUser(user) {
  return user.roleCode === 'PROJECT_ADMIN' || user.roleCode === 'PROJECT_SUPERVISOR'
}

function shouldForceProjectScopedRelogin(user) {
  if (!user || !isProjectScopedUser(user)) {
    return false
  }
  if (!Array.isArray(user.projectGroupIds)) {
    return true
  }
  const ids = normalizeProjectGroupIds(user.projectGroupIds)
  if (ids.length) {
    return false
  }
  const names = user.projectGroupNames || []
  const legacyName = (user.projectGroupName || '').trim()
  return names.length > 0 || !!legacyName
}

function loadStoredUser() {
  try {
    const raw = localStorage.getItem('user')
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

const storedToken = localStorage.getItem('token') || ''
let initialToken = storedToken && !isTokenExpired(storedToken) ? storedToken : ''
let initialUser = initialToken ? loadStoredUser() : null

// 旧版登录缓存不含 permissions，强制重新登录以免路由守卫死循环
if (initialUser && !Array.isArray(initialUser.permissions)) {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  initialToken = ''
  initialUser = null
}

// 项目管理员登录缓存缺少 projectGroupIds 时强制重新登录
if (initialUser && shouldForceProjectScopedRelogin(initialUser)) {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  initialToken = ''
  initialUser = null
}

if (storedToken && !initialToken) {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
}

const initialSelectedProjectGroupId = initialUser ? resolveSelectedProjectGroupId(initialUser) : null

export default new Vuex.Store({
  state: {
    token: initialToken,
    user: initialUser,
    selectedProjectGroupId: initialSelectedProjectGroupId
  },
  getters: {
    permissions(state) {
      return (state.user && state.user.permissions) || []
    }
  },
  mutations: {
    setAuth(state, payload) {
      state.token = payload.token
      state.user = payload
      state.selectedProjectGroupId = resolveSelectedProjectGroupId(payload)
      localStorage.setItem('token', payload.token)
      localStorage.setItem('user', JSON.stringify(payload))
      if (state.selectedProjectGroupId != null && payload.userId) {
        localStorage.setItem(projectGroupStorageKey(payload.userId), String(state.selectedProjectGroupId))
      }
    },
    setSelectedProjectGroupId(state, groupId) {
      state.selectedProjectGroupId = groupId
      const userId = state.user && state.user.userId
      if (userId != null && groupId != null) {
        localStorage.setItem(projectGroupStorageKey(userId), String(groupId))
      }
    },
    setPermissions(state, permissions) {
      if (state.user) {
        state.user = { ...state.user, permissions: permissions || [] }
        localStorage.setItem('user', JSON.stringify(state.user))
      }
    },
    logout(state) {
      state.token = ''
      state.user = null
      state.selectedProjectGroupId = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  }
})
